import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { ButtonHTMLAttributes, FC, ReactNode } from 'react';

export interface ITableSortLabelProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  children?: ReactNode;
  active: boolean;
  direction?: 'desc' | 'asc';
  onClick: (event: React.MouseEvent<unknown>) => void;
}

export const TableSortLabel: FC<ITableSortLabelProps> = ({
  children,
  active,
  direction = 'asc',
  onClick,
  className,
  ...props
}) => {
  const Icon = direction === 'desc' ? CaretDownOutlined : CaretUpOutlined;

  return (
    <button
      type={'button'}
      className={[
        'group inline-flex cursor-pointer items-center gap-1 border-0 bg-transparent p-0 text-inherit leading-6',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onClick}
      {...props}
    >
      {children}
      <Icon
        className={
          active ? 'text-[12px] leading-none opacity-100' : 'text-[12px] leading-none opacity-0 group-hover:opacity-50'
        }
      />
    </button>
  );
};
